import { createContext, useContext } from "react";

// The z-index of the portal layer the nearest enclosing `Modal` renders into — the shared
// `#modal-portal-root` (99999) or a dedicated root raised by `portalZIndex`. Undefined outside any modal.
export const PortalLayerContext = createContext<number | undefined>(undefined);

// For anything that portals a floating panel to <body> (dropdowns, popovers). A modal's root is
// `position: fixed`, i.e. its own stacking context, so a body-level panel below the root's z-index
// paints UNDER the whole modal — the trigger opens, nothing shows, and it reads as a dead control.
// That is the ImageCropper aspect Select after REF-6538 raised the cropper to 100002 while the panel
// stayed at 100000. Resolving the panel's z against the host layer makes that impossible by construction.
export const usePortalLayerZIndex = (defaultZIndex: number): number => {
  const hostLayer = useContext(PortalLayerContext);

  return hostLayer === undefined ? defaultZIndex : Math.max(defaultZIndex, hostLayer + 1);
};
